import { Button, Dialog, DialogActions, DialogContent, Grid2, Stack } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { StyledFieldSet } from 'components/StyledElements'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import DtoStationCampaign from '../../../../campaign/dto/DtoStationCampaign'
import Select from '../../../../components/forms/Select'
import Icon from '../../../../components/icon/Icon'
import DtoPiezometer from '../../../dto/DtoPiezometer'
import { CardTable } from 'components/datatable/NewTable'

const PiezometryAddToCampaignModal = ({
    isOpen = false,
    onClose = () => {},
    onValidate = () => { },
    stations = [],
}) => {
    const dispatch = useDispatch()
    const {
        piezometryCampaigns,
        piezometryCampaignStations,
        citiesIndex,
        piezometers,
    } = useSelector(store => ({
        piezometryCampaigns: store.PiezometryReducer.piezometryCampaigns,
        piezometryCampaignStations: store.PiezometryReducer.piezometryCampaignStations,
        citiesIndex: store.CityReducer.citiesIndex,
        piezometers: store.PiezometryReducer.piezometersLight,
    }), shallowEqual)

    const [campaign, setCampaign] = useState()

    const campaignStations = useMemo(() => {
        return piezometryCampaignStations.filter(s => s.campaignId === campaign).map(s => {
            const station = piezometers.find(p => p.id === s.stationId) || {}
            const selected = stations.some(st => st.id === station.id)
            return {
                ...station,
                selected,
                visitOrder: s.visitOrder ?? 0,
                stationId: station.id,
                city: citiesIndex[station.townCode]?.labelWithCode,
                nullValue: selected ? <Icon icon='check_box' /> : '',
            }
        }).filter(s => !!s.stationId)
    }, [campaign, citiesIndex, piezometers, piezometryCampaignStations, stations])

    const toAddStations = useMemo(() => {
        return stations.filter(s => !campaignStations.some(cs => cs.id === s.id)).map(s => ({
            ...s,
            selected: true,
            visitOrder: 0,
            city: citiesIndex[s.townCode]?.labelWithCode,
            nullValue: (<Icon icon='check_box' />),
        }))
    }, [campaignStations, citiesIndex, stations])

    const onClosePopin = () => {
        setCampaign()
        onClose()
    }

    const onValidatePopin = () => {
        if (!campaign) {
            dispatch(ToastrAction.toastrInfo(i18n.pleaseSelectCampaign))
        } else {
            const newStations = [...campaignStations, ...toAddStations].map(s => new DtoStationCampaign({
                campaignId: campaign,
                stationId: s.id,
                visitOrder: s.visitOrder,
            }))
            dispatch(CampaignAction.updateCampaignStations(newStations, 'piezometry', campaign))
                .then(() => {
                    dispatch(CampaignAction.fetchPiezometryCampaigns())
                    setCampaign()
                    onValidate()
                })
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth='xl'
            open={isOpen}
            onClose={onClosePopin}
            slotProps={{
                paper: {
                    sx: {
                        minHeight: '90vh',
                        maxHeight: '90vh',
                    },
                },
            }}
        >
            <DefaultDialogTitle
                title={i18n.addToCampaign}
                onClose={onClosePopin}
            />
            <DialogContent>
                <Stack spacing={1}>
                    <StyledFieldSet style={{ padding: '5 8 10 8' }}>
                        <Select
                            label={i18n.pleaseSelectCampaign}
                            options={piezometryCampaigns}
                            value={campaign}
                            onChange={setCampaign}
                            nullLabel='&nbsp;'
                        />
                    </StyledFieldSet>
                    <Grid2 container columnSpacing={2}>
                        <Grid2 size={6}>
                            <CardTable
                                title={i18n.newStations}
                                rows={toAddStations}
                                headers={['code', 'name', 'city', 'nullValue']}
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <CardTable
                                title={i18n.campaign}
                                rows={campaignStations}
                                headers={['code', 'name', 'city', 'nullValue']}
                            />
                        </Grid2>
                    </Grid2>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onValidatePopin}
                    variant='contained'
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

PiezometryAddToCampaignModal.propTypes = {
    stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometer)),
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
}

export default PiezometryAddToCampaignModal
